import React, { useEffect, useState } from "react";
import styles from "../../business-division.module.scss";
import { useTranslation } from "next-i18next";
import { breakpoints } from "../../../../../utils/breakpoints";
import LocationSvg from "/public/landings/assets/icons/business-division/location";
import DivisionArrowsSvg from "/public/landings/assets/icons/business-division/division-arrows";

const TimelineMark = ({ id, currentProduct }) => {
	const { t } = useTranslation();
	const isCurrentProduct = id === currentProduct;

	return (
		<div
			className={`${styles.divisionMark} ${isCurrentProduct ? styles.currentProduct : ""}`}
		>
			{isCurrentProduct ? (
				<LocationSvg className={`${styles.location} ${styles[`fill-${id}`]}`} />
			) : null}

			<span className={`${styles.divisor} ${styles[id]}`}></span>
			<div className="flex items-center mb-1.5">
				<span className={`${styles.markText} ${styles[`color-${id}`]}`}>
					{t(`businessDivision.${id}`)}
				</span>

				<DivisionArrowsSvg
					className={`${styles.divisionArrows} h-[27.5px] ${styles[`stroke-${id}`]}`}
				/>
			</div>

			{isCurrentProduct ? (
				<small className={`${styles.positionText} font-thin ${styles[`color-${id}`]}`}>
					{t("businessDivision.youAreHere")}
				</small>
			) : null}
		</div>
	);
};

const Timeline = ({
	divisionName,
	divisionDescription,
	divisionDescription2,
	id,
}) => {
	const { t } = useTranslation();
	const [timelineImg, setTimelineImg] = useState();

	const getMainTimelineImg = () => {
		let imgName = "timeline-desktop";
		if (
			typeof window !== undefined &&
			window.innerWidth <= Number.parseInt(breakpoints.m)
		) {
			imgName = "timeline-mobile";
		}

		return imgName;
	};

	useEffect(() => {
		const handleResize = () => {
			setTimelineImg(getMainTimelineImg());
		};

		window.addEventListener("resize", handleResize);

		setTimelineImg(getMainTimelineImg());

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return (
		<div className={styles.timelineContainer}>
			<hr className={styles[id]} />
			<h3>
				{t("businessDivision.businessDivision")}: {divisionName}
			</h3>
			<h4>{divisionDescription}</h4>
			<h4 className={styles.last}>{divisionDescription2}</h4>

			<div className={styles.timeline}>
				<div className={styles.timelineMarks}>
					<TimelineMark id="acceleration" currentProduct={id} />
					<TimelineMark id="disruption" currentProduct={id} />
					<TimelineMark id="expansion" currentProduct={id} />
				</div>
				{!!timelineImg && (
					<img
						className={styles.timelineMainImg}
						src={`/landings/assets/icons/business-division/${timelineImg}.svg`}
						alt="timeline"
					/>
				)}
			</div>
		</div>
	);
};

export default Timeline;
